import { dependencies } from '../package.json';

export const SDK_API_CORE_VERSION = dependencies['@dynamic-labs/sdk-api-core'];

export const DYNAMIC_ICONIC_SPRITE_URL =
  'https://iconic.dynamic-static-assets.com/icons/sprite.svg';
